/*************************************
 *
 * 设置 HTML font-size
 *
 *************************************/

function setHtmlFontSize () {
  // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
  let clientWidth = document.documentElement.clientWidth || document.body.clientWidth
  let dom = document.getElementsByTagName('html')[0]
  // 设置根元素字体大小
  dom.style.fontSize = (clientWidth / 23.43) + 'px'
  // dom.style.fontSize = 16 * (clientWidth / 375) + 'px'
  // dom.style.fontSize = 100 + '%'
}

setHtmlFontSize()

window.onresize = function () {
  setHtmlFontSize()
}



// WEBPACK FOOTER //
// ./src/utils/pxConvertRem.js